window.addEventListener('load', function (event) {
  const thumbSlider = new Swiper('.pdp__images-thumbs', {
    wrapperClass: 'pdp__images-thumbs-track',
    slideClass: 'pdp__images-thumb',
    centeredSlides: false,
    slidesPerView: 'auto',
    a11y: {
      enabled: false
    },
    watchSlidesProgress: true,
    mousewheel: {
      invert: false,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        direction: 'horizontal',
        spaceBetween: 10
      },
      768: {
        direction: 'vertical',
        spaceBetween: 16
      },
      // when window width is >= 1025px
      1025: {
        direction: 'vertical',
        spaceBetween: 20
      }
    }
  });

  const mainSlider = new Swiper('.pdp__images-main', {
    wrapperClass: 'pdp__images-main-track',
    slideClass: 'pdp__image',
    speed: 500,
    loop: false,
    a11y: {
      enabled: false
    },
    spaceBetween: 20,
    mousewheel: {
      invert: false,
    },
    navigation: {
      nextEl: '.pdp__images-main-nav--next',
      prevEl: '.pdp__images-main-nav--prev',
    },
    pagination: {
      el: '.pdp__images-main__pagination',
      clickable: true,
    },
    thumbs: {
      swiper: thumbSlider,
    },
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      499: {
        slidesPerView: 'auto'
      },
      1025: {
        slidesPerView: 'auto',
      }
    }
  });

  // mainSlider.on('sliderMove', function () {
  //   document.querySelector('.pdp__images-main').classList.add('pdp__images-main--animate');
  // });

  // mainSlider.on('touchEnd', function () {
  //   document.querySelector('.pdp__images-main').classList.remove('pdp__images-main--animate');
  // });


  let zoomKeydownHandler = null;
  let zoomInteractiveCleanup = null;

  function closeZoom() {
    const overlay = document.getElementById('zoomModal');
    if (overlay) overlay.remove();
    document.body.classList.remove('modal-open');
    if (zoomKeydownHandler) {
      document.removeEventListener('keydown', zoomKeydownHandler);
      zoomKeydownHandler = null;
    }
    if (zoomInteractiveCleanup) {
      zoomInteractiveCleanup();
      zoomInteractiveCleanup = null;
    }
  }

  // Lets the shopper drag-to-pan and pinch/scroll/button-zoom the image
  // in-place, instead of only offering one fixed "fit to screen" view.
  function setupInteractiveZoom(img, container) {
    const MIN_SCALE = 1;
    const MAX_SCALE = 4;
    const ZOOM_STEP = 0.5;
    const DOUBLE_TAP_SCALE = 2.5;

    let scale = MIN_SCALE;
    let translateX = 0;
    let translateY = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let pinchStartDistance = 0;
    let pinchStartScale = MIN_SCALE;
    let lastTapTime = 0;

    img.classList.add('zoom-img--interactive');

    function applyTransform() {
      img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
      img.style.cursor = scale > MIN_SCALE ? 'grab' : 'zoom-in';
    }

    // offsetWidth/Height reflect the untransformed layout size, so this
    // stays correct regardless of the current scale.
    function clampTranslate() {
      const containerRect = container.getBoundingClientRect();
      const scaledWidth = img.offsetWidth * scale;
      const scaledHeight = img.offsetHeight * scale;
      const maxX = Math.max(0, (scaledWidth - containerRect.width) / 2);
      const maxY = Math.max(0, (scaledHeight - containerRect.height) / 2);
      translateX = Math.min(maxX, Math.max(-maxX, translateX));
      translateY = Math.min(maxY, Math.max(-maxY, translateY));
    }

    function setScale(newScale) {
      scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale));
      if (scale === MIN_SCALE) {
        translateX = 0;
        translateY = 0;
      }
      clampTranslate();
      applyTransform();
    }

    function toggleZoom() {
      setScale(scale > MIN_SCALE ? MIN_SCALE : DOUBLE_TAP_SCALE);
    }

    // + / − controls
    const controls = document.createElement('div');
    controls.className = 'zoom-controls';

    const zoomOutBtn = document.createElement('button');
    zoomOutBtn.type = 'button';
    zoomOutBtn.className = 'zoom-control zoom-control--out';
    zoomOutBtn.setAttribute('aria-label', 'Zoom out');
    zoomOutBtn.textContent = '−';
    zoomOutBtn.addEventListener('click', () => setScale(scale - ZOOM_STEP));

    const zoomInBtn = document.createElement('button');
    zoomInBtn.type = 'button';
    zoomInBtn.className = 'zoom-control zoom-control--in';
    zoomInBtn.setAttribute('aria-label', 'Zoom in');
    zoomInBtn.textContent = '+';
    zoomInBtn.addEventListener('click', () => setScale(scale + ZOOM_STEP));

    controls.appendChild(zoomOutBtn);
    controls.appendChild(zoomInBtn);

    // Scroll wheel to zoom (desktop)
    container.addEventListener('wheel', (event) => {
      event.preventDefault();
      setScale(scale + (event.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP));
    }, { passive: false });

    // Double-click to toggle zoom
    img.addEventListener('dblclick', toggleZoom);

    // Drag to pan (mouse) once zoomed in
    img.addEventListener('mousedown', (event) => {
      if (scale <= MIN_SCALE) return;
      isDragging = true;
      img.classList.add('zoom-img--dragging');
      dragStartX = event.clientX - translateX;
      dragStartY = event.clientY - translateY;
      applyTransform();
      event.preventDefault();
    });

    function onWindowMouseMove(event) {
      if (!isDragging) return;
      translateX = event.clientX - dragStartX;
      translateY = event.clientY - dragStartY;
      clampTranslate();
      applyTransform();
    }

    function onWindowMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      img.classList.remove('zoom-img--dragging');
      applyTransform();
    }

    window.addEventListener('mousemove', onWindowMouseMove);
    window.addEventListener('mouseup', onWindowMouseUp);

    // Removed by closeZoom() so repeated open/close cycles don't pile up
    // dead window-level listeners.
    zoomInteractiveCleanup = () => {
      window.removeEventListener('mousemove', onWindowMouseMove);
      window.removeEventListener('mouseup', onWindowMouseUp);
    };

    // Touch: single-finger pan, two-finger pinch to zoom, double-tap to toggle
    function touchDistance(touches) {
      return Math.hypot(
        touches[0].clientX - touches[1].clientX,
        touches[0].clientY - touches[1].clientY
      );
    }

    container.addEventListener('touchstart', (event) => {
      if (event.touches.length === 2) {
        pinchStartDistance = touchDistance(event.touches);
        pinchStartScale = scale;
      } else if (event.touches.length === 1) {
        const now = Date.now();
        if (now - lastTapTime < 300) {
          toggleZoom();
        }
        lastTapTime = now;

        if (scale > MIN_SCALE) {
          isDragging = true;
          img.classList.add('zoom-img--dragging');
          dragStartX = event.touches[0].clientX - translateX;
          dragStartY = event.touches[0].clientY - translateY;
        }
      }
    }, { passive: true });

    container.addEventListener('touchmove', (event) => {
      if (event.touches.length === 2 && pinchStartDistance) {
        event.preventDefault();
        const newDistance = touchDistance(event.touches);
        setScale(pinchStartScale * (newDistance / pinchStartDistance));
      } else if (event.touches.length === 1 && isDragging) {
        event.preventDefault();
        translateX = event.touches[0].clientX - dragStartX;
        translateY = event.touches[0].clientY - dragStartY;
        clampTranslate();
        applyTransform();
      }
    }, { passive: false });

    container.addEventListener('touchend', (event) => {
      if (event.touches.length < 2) pinchStartDistance = 0;
      if (event.touches.length === 0) {
        isDragging = false;
        img.classList.remove('zoom-img--dragging');
      }
    });

    applyTransform();

    return controls;
  }

  function openZoom(src) {
    closeZoom(); // clean up any existing modal + listeners first

    document.body.classList.add('modal-open');

    // overlay
    const overlay = document.createElement('div');
    overlay.id = 'zoomModal';

    // scrollable wrapper
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'zoom-container';

    // zoomed image
    const zoomImg = document.createElement('img');
    zoomImg.src = src;
    zoomImg.alt = '';

    // visible close button
    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'zoom-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeZoom);

    // close when clicking the backdrop (outside the image)
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target === scrollContainer) closeZoom();
    });

    zoomKeydownHandler = (event) => {
      if (event.key === 'Escape') closeZoom();
    };
    document.addEventListener('keydown', zoomKeydownHandler);

    scrollContainer.appendChild(zoomImg);
    overlay.appendChild(scrollContainer);
    overlay.appendChild(closeBtn);

    if (window.viairIndustrialProduct === true) {
      // Interactive pan/zoom for industrial products; closing is via the
      // close button, backdrop click, or Escape (not a click on the image,
      // since that's now used for double-click-to-zoom and drag-to-pan).
      overlay.appendChild(setupInteractiveZoom(zoomImg, scrollContainer));
    } else {
      // Legacy behavior: tap the oversized image to close.
      zoomImg.addEventListener('click', closeZoom);
    }

    document.body.appendChild(overlay);
  }

  //resize the thumbs height
  function eqHeight() {
    // Industrial-collection products use click-to-zoom (same modal as mobile)
    // instead of hover-zoom, even on desktop widths — see theme.liquid.
    const useClickZoom = window.innerWidth <= 767 || window.viairIndustrialProduct === true;
    const containers = document.querySelectorAll('.pdp__image');

    if (window.innerWidth > 767) {
      let thumbSliderHeight = document.querySelector('.pdp__images-main img').offsetHeight;
      //console.log(thumbSliderHeight);
      document.querySelector('.pdp__images-thumbs').style.height = thumbSliderHeight + 'px';
    } else {
      document.querySelector('.pdp__images-thumbs').style.height = 'auto';
    }

    if (!useClickZoom) {
      containers.forEach((container) => {
        // Get the image inside the current container
        const image = container.querySelector('img');

        // Update the transform-origin on mousemove
        container.addEventListener('mousemove', (event) => {
          const rect = container.getBoundingClientRect();
          const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
          const yPercent = ((event.clientY - rect.top) / rect.height) * 100;
          image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        });

        // Remove the inline style on mouseleave to reset the transform-origin
        container.addEventListener('mouseleave', () => {
          image.style.removeProperty('transform-origin');
        });
      });
    } else {
      containers.forEach(container => {
        const src = container.querySelector('img').src;
        container.addEventListener('click', () => openZoom(src));
      });
    }

    mainSlider.update();
    thumbSlider.update();
  }

  eqHeight();

  window.addEventListener("resize", eqHeight);

  window.addEventListener("pdfImagesLoaded", eqHeight);

  // Function to simulate select option change
  function simulateSelectChange(selectElement, value) {
    // Find the option with the given value
    const option = selectElement.querySelector(`option[value=${JSON.stringify(value)}]`);

    // If option found, select it and trigger change event
    if (option) {
      selectElement.value = value;
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      console.error(`Option with value "${value}" not found`);
    }
  }

  document.querySelectorAll('.custom-selected__value').forEach(trigger => {
    trigger.addEventListener('click', function () {
      this.parentNode.classList.toggle('custom-select--active');
      this.parentNode.querySelector('.custom-select__dropdown').classList.toggle('custom-select__dropdown--active');

      document.addEventListener('click', function (e) {
        if (trigger && !trigger.contains(e.target)) {
          // Click was outside of the element, do something
          trigger.parentNode.classList.remove('custom-select--active');
          trigger.parentNode.querySelector('.custom-select__dropdown').classList.remove('custom-select__dropdown--active');
        }
      });
    });
  });

  document.querySelectorAll('.custom-select__value').forEach(option => {
    option.addEventListener('click', function () {
      let value = this.getAttribute('value');
      let title = this.textContent.trim();
      // console.log(value);
      // console.log(title);
      this.parentNode.querySelector('.custom-select__value[selected="selected"]').removeAttribute("selected");
      this.setAttribute("selected", "selected");
      this.closest('.custom-select__dropdown').classList.remove('custom-select__dropdown--active');
      let select = this.closest('.product-form__input--dropdown').querySelector('.select__select');
      this.closest('.product-form__input--dropdown').querySelector('.custom-selected__value').value = title;
      // console.log('value: ', value);
      // console.log('select: ', select);
      simulateSelectChange(select, value);
    })
  })

  // Update gallery image on variant click
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  let previousUrl = '';
  const observer = new MutationObserver(function (mutations) {
    if (window.location.href !== previousUrl) {
      previousUrl = window.location.href;
      //console.log(`URL changed from ${previousUrl} to ${window.location.href}`);
      let variantId = getUrlParameter('variant');
      let thumb = document.querySelector(`.pdp__images-thumb[data-id*="${variantId}"]`);
      // console.log(variantId);
      // console.log(thumb);
      if (thumb) {
        let goTo = parseInt(thumb.dataset.index) - 1;
        mainSlider.slideTo(goTo, 500);
      }
    }
  });
  const config = { subtree: true, childList: true };

  // start listening to changes
  observer.observe(document, config);
}, false);



document.addEventListener("DOMContentLoaded", function () {
  var thumbnail = document.querySelector(".pdp__image--main_video_thumb");
  var iframeContainer = document.querySelector(".pdp__image--main_video--iframe");

  if (iframeContainer) {
    var iframe = iframeContainer.querySelector("iframe");
    var closeButton = iframeContainer.querySelector(".close-iframe");

    if (thumbnail && iframe && closeButton) {
      thumbnail.addEventListener("click", function () {
        var videoId = thumbnail.getAttribute("data-external-id");
        iframe.src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
        iframeContainer.style.display = "flex";
        thumbnail.style.display = "none";

        closeButton.addEventListener("click", function () {
          iframe.src = "";
          iframeContainer.style.display = "none";
          thumbnail.style.display = "block";
        });
      });
    }
  }
});
